<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->


    <v-card v-if="proceed_flag" align="center" justify="center" class="box">
      <!-- <v-card-title> Add Visitor </v-card-title> -->
      <v-toolbar flat dense class="toolbar justify-center align-center">
        <v-spacer></v-spacer>
        <v-toolbar-title class="text-center">Visitor E-Pass</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- <v-btn class="button" @click="generatePDF()">GET PDF </v-btn> -->
      <!-- <v-btn class="button" @click="exportToPDF">GET PDF</v-btn> -->

      <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print('printable_div_id')">
        <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
      </v-btn>

      <v-row dense>
        <v-col cols="12" sm="2" md="3"></v-col>
        <v-col cols="12" sm="4" md="3">
          <v-img style="width: 140px; height: 100px" :src="org_basic_data.trust_logo" />

        </v-col>
        <v-col cols="12" sm="4" md="3" style="margin-top: 60px;">
          <b> {{ org_basic_data.school_name }}</b>

        </v-col>
      </v-row>
      <!-- <v-card-text> -->

      <!-- content for ui -->
      <v-card class="box1">
        <div ref="document">

          <v-row dense>
            <v-col cols="12" class="print-visible">
              <v-card class="pa-4" outlined>
                <h3 class="text-center">Visitor E-Pass</h3>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-img style="width: 250px; height: 140px" class="shrink" contain :src="logo"></v-img>
            </v-col>
          </v-row>
          <v-row dense justify="center" v-if="photo == null">

            <v-col cols="12" md="4" sm="4">
              <qrcode-vue v-if="walkin_visitor_epass_url != null" :value="walkin_visitor_epass_url" :size="150"
                level="H" />
            </v-col>
          </v-row>
          <v-row dense v-else>
            <v-col cols="12" sm="2" md="2"></v-col>
            <v-col cols="12" md="4" sm="4">
              <v-img style="width: 250px; height: 155px" class="shrink mr-2 vi-img" contain :src="photo"
                v-if="photo != null"></v-img>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <qrcode-vue v-if="walkin_visitor_epass_url != null" :value="walkin_visitor_epass_url" :size="150"
                level="H" />
            </v-col>
          </v-row>
          <!-- simple table  -->

          <v-col cols="12" sm="12" md="12">
            <v-simple-table id="page">
              <tbody class="tablebody">
                <tr>
                  <td>Name</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.visitor_data.visitor_name }}
                  </td>
                </tr>
                <tr>
                  <td>Mobile No</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.visitor_data.visitor_mobile }}
                  </td>
                </tr>
                <tr>
                  <td>Address</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.visitor_data.visitor_address }}
                  </td>
                </tr>
                <tr v-if="visitor_visit_data.From_date">
                  <td>Scheduling Date</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.From_date }}
                  </td>
                </tr>
                <tr>
                  <td>Appointment with</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.vv_whom_to }}
                  </td>
                </tr>
                <tr v-if="visitor_visit_data.vehicle_number">
                  <td>Vehicle Number</td>
                  <td class="tdata2">
                    {{ visitor_visit_data.vehicle_number }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-row class="ma-2"> <strong style="font-size: 1em;">Instructions to Visitor :-</strong></v-row>
          <v-row dense v-for="(i, index) in instructions_list" :key="index">
            <ul class="inst">
              <!-- <li style="padding-left: 0.3em;">{{ i.value }}</li> -->
              <li style="padding-left: 0.3em;" v-html="i.value"></li>

            </ul>
          </v-row>
          <br>
        </div>
      </v-card>
      <br>


      <v-row justify="center" class="ma-2 no-display"
        v-if="this.Eps_uid != null && this.Eps_uid != '' && this.Eps_uid != 'null'">
        <div>
          <v-btn color="info" @click="checkedinvisitor()">Check In
          </v-btn>
        </div>

      </v-row>


    </v-card>
  </div>

</template>

<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

// import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
export default {
  components: {
    QrcodeVue,
    VueHtml2pdf,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    logo: null,
    Eps_uid: "",
    proceed_flag: false,
    visitor_visit_data: null,
    walkin_visitor_epass_url: null,
    photo: null,
    org_basic_data: [],
    instructions_list: [],
    ///////////////////
    htmlToPdfOptions: {
      margin: 10,
      padding: 20,

      filename: `hehehe.pdf`,

      image: {
        type: "jpeg",
        quality: 0.98,
      },

      enableLinks: false,

      html2canvas: {
        scale: 1,
        useCORS: true,
      },

      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "landscape",
      },
    },
    progress: 0,
  }),

  mounted() {

    this.Eps_uid = localStorage.getItem("EPS-uid");

    console.log("params", this.$route.query.o); // outputs 'yay'
    console.log("params", this.$route.query.t); // outputs 'yay'
    //  return
    const formdata = {
      o: this.$route.query.o,
      t: this.$route.query.t,
      mobile: this.$route.query.mob,
      vvid: this.$route.query.vvid,
    };
    //alert(formdata.o)
    this.overlay = true;
    axios
      .post("/visitorManagement/getEpassData", formdata)
      .then((res) => {
        if (res.data.flag == "YES") {

          this.overlay = false,
            this.logo = res.data.logo;
          this.visitor_visit_data = res.data.visitor_visit_data;
          this.walkin_visitor_epass_url = res.data.walkin_visitor_epass_url;
          this.org_basic_data = res.data.org_basic_data
          this.instructions_list = res.data.instructions_list;
          this.proceed_flag = true;
          this.photo = res.data.photo_file_path_new;
          // localStorage.getItem("awspath") +
          // this.visitor_visit_data.photo_file_path +
          // this.visitor_visit_data.photo_file_name;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          this.overlay = false;
        }
        this.overlay = false;
      })
      .catch((error) => {
        this.onerror(error);
        this.overlay = false;
      })
      .finally(() => {
        this.overlay = false;
        // this.selected_date=""
      });


  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
    checkedinvisitor() {
      const formdata = {
        o: this.$route.query.o,
        t: this.$route.query.t,
        mobile: this.$route.query.mob,
        vvid: this.$route.query.vvid,
      };
      axios
        .post("/visitorManagement/checkInByQrcode", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);

          }

        })
        .catch((error) => {
          this.onerror(error);

        })
        .finally(() => {
        });
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    async exportToPDF() {
      console.log("in pdf");
      await html2pdf(this.$refs.document, {
        enableLinks: false,
        margin: 0,
        padding: 0,
        filename: "document.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 1, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
      console.log("out of pdf");
    },
    // pdf gener
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
      // html2pdf(this.$refs.document, {
      //   margin: 2,
      //   filename: "Epass.pdf",
      //   image: { type: "jpg", quality: 0.98 },
      //   html2canvas: { dpi: 192, letterRendering: true },
      //   jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
      // });
    },
    // validation code
    validName() {
      this.validMob();
      if (/[^a-zA-Z\s]/.test(this.visitor_name)) {
        this.error = "Input value contains other syantax.";
        this.showSnackbar("red", "Input value contains other syantax.");
        // alert("Input value contains other syantax");
        this.name_error = true;
        this.overlay = false;
      } else {
        this.name_error = false;
        this.error = "";
      }
    },

    validMob() {
      var a = document.getElementById("mobilenumber").value;

      if (a.length < 10 || a.length > 10 || isNaN(a) || a == "") {
        this.mob_error1 = "Please Enter Valid Number";

        this.showSnackbar("red", "Please Enter Valid Number");
        this.mob_error = true;
        return false;
      } else {
        this.mob_error = false;
      }
    },

    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },
    reset() {
      // this.save_edit = "Add Myself";
      //   this.edit_io_id = null;
      this.visitor_name = "";
      this.visitor_mobileno = "";
      this.visitor_address = "";
    },
    // validation code end
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    ///////////////////////////
    addVisitor() {
      //validation on mobileno and name // mandatory
      this.validName();
      this.validMob();
      if (this.hasWhiteSpace(this.visitor_name) || this.visitor_name == null) {
        this.showSnackbar("#b71c1c", "Please Enter Name");
        return;
      }

      const formdata = {
        visitor_address: this.visitor_address,
        visitor_name: this.visitor_name,
        visitor_mobileno: this.visitor_mobileno,
        o: this.$route.query.o,
        t: this.$route.query.t,
        // save_edit: this.save_edit,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/addVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            // this.qrcode = true
            this.showSnackbar("green", "Visitor Added Successfully");
            this.reset();
          } else {
            this.reset();

            //  this.qrcode = false
            this.showSnackbar("red", res.data.snackbar);


            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getVisitor() {
      //validation on mobileno and name // mandatory
      this.validMob();

      const formdata = {
        visitor_mobileno: this.visitor_mobileno,
        o: this.$route.query.o,
        t: this.$route.query.t,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/getVisitor", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitor_present = true;
            this.visitor_address = res.data.visitor_address;
            this.visitor_name = res.data.visitor_name;
            //  this.qrcode = true
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);

            //  this.qrcode = false
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          // this.qrcode = false
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
  },
};
</script>

<style scoped>
.print-visible {
  display: none;
}

ul.inst {
  list-style-type: "*";
  font-weight: 500;
  font-size: 14px;
}

.alert {
  /* padding: 5px 10px; */
  /* border: 1px solid #ff72728a; */
  display: inline-block;
  color: #f30808;
  /* border-radius: 4px; */
}

.box1 {
  background-color: white !important;
  /* margin: 8px !important;
  padding: 8px; */
  border: 2px solid #8360c3 !important;
  width: 45%;
  /* margin-left: 28%; */
  /* margin: 3%; */
}

#page tr,
td {
  /* padding: 0;  */
  /* margin-left: 0px; */
  font-size: large;
  text-align: left;
}

.schl-logo {
  width: 20%;
}

.tdata2 {
  font-weight: bolder;
}

tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}

td {
  margin: 0.1rem !important;
  padding: 0.1rem !important;
  font-size: small;
}

.vi-img {
  border-radius: 22%;
  /*   
  max-width: 200px;
  max-height: 200px; */
}

/* mobile view */
@media only screen and (max-width: 600px) {
  .box1 {
    background-color: white !important;
    /* margin: 8px !important;
  padding: 8px; */
    border: 2px solid #8360c3 !important;
    width: 95%;
    /* margin-left: 28%; */
    margin: 3%;
  }

}

@media print {
  .box1 {
    width: 100%;
    margin: 0;
  }

  .instruction {}

  .card {
    border: none !important;
    font-size: large !important;
  }

  .pagebreak {
    page-break-before: always;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  table,
  td,
  tr {
    break-inside: avoid-page;
  }

  body,
  tr,
  th,
  td {
    font-size: large !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }



  v-card {
    border: none !important;
  }

  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    orientation: portrait;
    /* orientation: landscape; */
    /* size: 12in 20in; */
  }

  thead {
    font-weight: bold !important;
  }

  table,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }

  .print-visible {
    display: block !important;
  }

}
</style>